module.exports = __webpack_public_path__ + "img/arrow_left_3.3fafab31.svg";